import { getMessage } from '@Locale/locale.ts';

type ValidElement = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
export type ValidatorFunction = (element: ValidElement) => string;
export type Validator = ValidatorFunction[] | ValidatorFunction;

export function validate(element?: ValidElement | null, validators?: Validator): string {
    if (!element) {
        return '';
    }
    let innerValidations: ValidatorFunction[] = [];
    if (validators === undefined) {
        innerValidations = [];
    }

    if (validators !== undefined && !Array.isArray(validators)) {
        innerValidations = [validators];
    }

    innerValidations = [
        ...innerValidations,
        (value: ValidElement) => patternMismatchValidator(value, getMessage('validation_invalid_format')),
        (value: ValidElement) => valueMissingValidator(value, getMessage('validation_missing')),
    ];

    for (const validator of innerValidations) {
        const message = validator(element);
        if (message) {
            return message;
        }
    }

    return '';
}

// Some default validators for built in input attributes such as pattern and required
// They are run at the end, so if you want to override them, you can add your own validator
// to the array and these will not be run.

function patternMismatchValidator(value: ValidElement, message: string): string {
    if (value.validity.patternMismatch) {
        return message;
    }
    return '';
}
function valueMissingValidator(value: ValidElement, message: string): string {
    if (value.validity.valueMissing) {
        return message;
    }
    return '';
}
